import { Icons } from "assets/icons";
import DisplayPrice from "components/common/DisplayPrice";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import { CustomerDashboardEventStatus, StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import { usePermission } from "hooks/usePermission";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CurrencySymbol, formatUTCDate } from "utils/utils";

const STATIC_POS_ACTIVITY = [
  {
    _id: "pos_001",
    transactionId: "TXN-1001",
    customerName: "Mohammed Al-Otaibi",
    vehicle: "Toyota Corolla",
    plateNumber: "AJB9839",
    service: "Full Wash",
    amount: 25,
    paymentMethod: "Card",
    kioskId: "POS-01",
    status: "completed",
    createdAt: "2025-03-28T08:10:00Z",
  },
  {
    _id: "pos_002",
    transactionId: "TXN-1002",
    customerName: "Noura Al-Ghamdi",
    vehicle: "Honda Civic",
    plateNumber: "HDV5687",
    service: "Premium Wash",
    amount: 40,
    paymentMethod: "Cash",
    kioskId: "POS-02",
    status: "completed",
    createdAt: "2025-03-28T09:20:00Z",
  },
  {
    _id: "pos_003",
    transactionId: "TXN-1003",
    customerName: "Khalid Al-Dosari",
    vehicle: "Nissan Altima",
    plateNumber: "RSY2389",
    service: "Basic Wash",
    amount: 15,
    paymentMethod: "Mada",
    kioskId: "POS-01",
    status: "failed",           // payment declined
    createdAt: "2025-03-28T10:05:00Z",
  },
  {
    _id: "pos_004",
    transactionId: "TXN-1004",
    customerName: "Reem Al-Qahtani",
    vehicle: "Hyundai Elantra",
    plateNumber: "WIS2381",
    service: "Full Wash",
    amount: 25,
    paymentMethod: "Apple Pay",
    kioskId: "POS-03",
    status: "in_progress",      // currently being washed
    createdAt: "2025-03-29T07:45:00Z",
  },
  {
    _id: "pos_005",
    transactionId: "TXN-1005",
    customerName: "Abdulrahman Al-Shehri",
    vehicle: "Ford Fusion",
    plateNumber: "LMN7890",
    service: "Premium Wash",
    amount: 40,
    paymentMethod: "STC Pay",
    kioskId: "POS-02",
    status: "refunded",         // customer requested refund
    createdAt: "2025-03-29T11:30:00Z",
  },
];
const KioskActivity = () => {
  const { t } = useTranslation();
  const { noPlans } = Icons || {};
  const { canAction } = usePermission();
  const { canView } = canAction("vehicles");

  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = STATIC_POS_ACTIVITY.filter(
    (item) =>
      item.transactionId.toLowerCase().includes(keyword.toLowerCase()) ||
      item.customerName.toLowerCase().includes(keyword.toLowerCase())
  );

  const columns = useMemo(
    () => [
      {
        header: t("Transaction ID"),
        key: "transactionId",
        render: (value) => <strong>{value}</strong>,
      },
      {
        header: t("Customer"),
        key: "customerName",
      },
      {
        header: t("Vehicle"),
        key: "vehicle",
      },
      {
        header: t("Plate Number"),
        key: "plateNumber",
      },
      {
        header: t("Amount"),
        key: "amount",
        render: (value) => <DisplayPrice value={value} />,
      },
      {
        header: t("Payment"),
        key: "paymentMethod",
      },
      {
        header: t("POS"),
        key: "kioskId",
      },
      {
        header: t("Date"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
    ],
    [t]
  );

  if (!canView) return null;

  return (
    <div className="page-content addons_page">
      <h4 className="page_title mb-3">{t("POS Activity")}</h4>

      <FilterBar
        keyword={keyword}
        setKeyword={setKeyword}
        keywordPlaceholder={t("Search by transaction or customer")}
        filters={[]}
        selectedFilters={{ keyword }}
        onSearch={() => {}}
        onReset={() => setKeyword("")}
        isBtn={false}
        isDateRange={false}
      />

      {filtered.length === 0 && (
        <NoDataFound title={t("No POS activity found")} icon={noPlans} />
      )}

      {filtered.length > 0 && (
        <>
          <DataTable columns={columns} data={filtered} t={t} />
          <Paginations
            currentPage={currentPage}
            totalPages={1}
            totalCount={filtered.length}
            onPageChange={setCurrentPage}
          />
        </>
      )}
    </div>
  );
};

export default KioskActivity;